



























































































































































































import {
  defineComponent,
  ref,
  useFetch,
  PropType,
  computed,
  watch,
  useContext,
} from "@nuxtjs/composition-api";
import { useRegionStore } from "~/stores/extensionApi/region";
import useStore from "~/modules/pageExten/composables/useStore";
import { FindStoreResults } from "~/modules/pageExten/composables/useStore/useStore";
import {
  gotoGgMap,
  getCurrentDay,
  getStoreStatusText,
  getStoreStatusStyle,
} from "~/modules/pageExten/helpers/store";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import { useClevertapStore } from "~/stores/clevertap";
import { useProduct } from "~/modules/catalog/product/composables/useProduct";

export default defineComponent({
  name: "ProductInStore",
  components: {
    SkeletonLoader,
  },
  props: {
    selectedOption: {
      type: Object as PropType<{ size: any; color: any }>,
      required: true,
    },
    parentSku: {
      type: String as PropType<string>,
      default: "",
    },
    availableOptions: {
      type: Object as PropType<{ size: any[]; color: any[] }>,
      default: null,
    },
  },
  setup(props) {
    const { findStoreByProduct, loading, error } = useStore();
    const regionStore = useRegionStore();
    const clevertapStore = useClevertapStore();
    const { app } = useContext();
    const { getProductList } = useProduct("product-detail");
    const isOpenOption = ref("");
    const isOpenOptionDistrict = ref("");
    const selectedCity = ref({
      id: null,
      label: null,
    });
    const selectedDistrict = ref({
      id: null,
      label: null,
    });
    const storeData = ref<FindStoreResults[]>([]);
    const listStores = ref<FindStoreResults[]>([]);
    const districts = ref<any[]>([]);
    const states = ref([]);
    const productData = ref(null);

    const openSelect = computed(() => {
      return ((props.selectedOption.color &&
        props.availableOptions.color.length > 0) ||
        (!props.selectedOption.color &&
          !props.availableOptions.color.length)) &&
        ((props.selectedOption.size &&
          props.availableOptions.size.length > 0) ||
          (!props.selectedOption.size && !props.availableOptions.size.length))
        ? ""
        : "disabled";
    });

    // Function to track store availability search results in CleverTap
    const trackStoreAvailability = () => {
      if (!process.client || !window.clevertap) return;
      if (!storeData.value || storeData.value.length === 0) return;
      if (!productData.value) return;

      try {
        // Get product data
        const product = productData.value;
        const color = props.selectedOption?.color?.label || "";
        const size = props.selectedOption?.size?.label || "";
        const itemId = `${props.parentSku}-${color}-${size}`;

        // Get basic product information for tracking
        const origin = window.location.origin;
        const productUrl = product?.url_key
          ? `${origin}/${product.url_key}${product.url_suffix || ""}`
          : "";
        const imageUrl = product?.image?.url || "";

        // Get price information
        let regularPrice = 0;
        let finalPrice = 0;

        if (product?.price_range) {
          if (product.price_range.maximum_price) {
            regularPrice =
              product.price_range.maximum_price.regular_price?.value || 0;
            finalPrice =
              product.price_range.maximum_price.final_price?.value || 0;
          } else if (product.price_range.minimum_price) {
            regularPrice =
              product.price_range.minimum_price.regular_price?.value || 0;
            finalPrice =
              product.price_range.minimum_price.final_price?.value || 0;
          }
        }

        // Prepare base tracking data
        const trackingData = {
          city: selectedCity.value.label || "",
          product_id: props.parentSku || "",
          item_id: itemId,
          item_name: product?.name || "",
          item_price: regularPrice,
          item_discount_price: finalPrice,
          item_url: productUrl,
          item_image_url: imageUrl,
          store_count: storeData.value.length,
        };

        // Add data for each store
        storeData.value.forEach((store, index) => {
          // Include up to 5 stores to avoid payload size issues
          if (index < 5) {
            const storeIndex = index + 1;

            // Use store.simistorelocator_id as store_id if available
            trackingData[`store_id_${storeIndex}`] =
              store.simistorelocator_id || `store-${storeIndex}`;
            trackingData[`store_name_${storeIndex}`] = store.store_name;
            trackingData[`store_address_${storeIndex}`] = store.address;

            // Use store.phone directly which has the correct format from the sample (024 3267 6030)
            trackingData[`store_phone_number_${storeIndex}`] = store.phone;

            // Combine latitude and longitude with a comma as shown in sample data's description field
            trackingData[
              `store_location_${storeIndex}`
            ] = `${store.latitude}, ${store.longitude}`;

            // Determine availability status correctly
            // product_status: 1 = Available, 2 = Limited Stock, 0 = Not Available
            trackingData[`is_item_available_${storeIndex}`] =
              (store as any).product_status === 1 ||
              (store as any).product_status === 2;

            // Provide user-friendly message based on product_status
            trackingData[`info_message_${storeIndex}`] =
              (store as any).product_status === 1
                ? "Còn hàng"
                : (store as any).product_status === 2
                ? "Còn ít hàng"
                : "Hết hàng";
          }
        });

        // Send the event to CleverTap
        clevertapStore.itemAvailableStoreCleverTap({
          clevertap: window.clevertap,
          data: trackingData,
        });
      } catch (error) {
        console.error("Error tracking store availability:", error);
      }
    };

    // Fetch product data for tracking
    const fetchProductData = async () => {
      if (!props.parentSku) return;

      try {
        const searchParams = {
          filter: {
            sku: {
              eq: props.parentSku,
            },
          },
        };

        const result = await getProductList(searchParams);
        if (result?.items && result.items.length > 0) {
          productData.value = result.items[0];
        }
      } catch (error) {
        console.error("Error fetching product data:", error);
      }
    };

    const { fetch } = useFetch(async () => {
      if (!regionStore.getStorelocatorData("VN")) {
        await regionStore.fetchStateStorelocatorData("VN");
      }
      states.value = regionStore.getStorelocatorData("VN");
      if (0 < states.value.length) {
        states.value = customSort(states.value);
      }

      // Fetch product data on initial load
      await fetchProductData();
    });

    const customSort = (data) => {
      const fixedOrder = ["Hà Nội", "Hồ Chí Minh"];

      const fixedItems = [];
      const restItems = [];

      for (const item of data) {
        if (fixedOrder.includes(item.value)) {
          fixedItems.push(item);
        } else {
          restItems.push(item);
        }
      }

      // Sắp xếp phần còn lại theo tên (value) alphabet (tiếng Việt có dấu)
      restItems.sort((a, b) =>
        a.value.localeCompare(b.value, "vi", { sensitivity: "base" })
      );

      // Đảm bảo đúng thứ tự Hà Nội trước, Hồ Chí Minh sau
      fixedItems.sort(
        (a, b) => fixedOrder.indexOf(a.value) - fixedOrder.indexOf(b.value)
      );

      return [...fixedItems, ...restItems];
    }

    const chooseCity = (state) => {
      if (state) {
        selectedCity.value.id = state.text;
        selectedCity.value.label = state.value;
        selectedDistrict.value.id = null;
        selectedDistrict.value.label = null;
      }
    };

    const chooseDistrict = (district) => {
      if (district) {
        selectedDistrict.value.id = district.id;
        selectedDistrict.value.label = district.value;
        listStores.value = storeData.value.filter(
          (store) => store.city === district.value
        );
      }
    };

    watch(
      () => selectedCity.value.id,
      async (newId) => {
        if (newId) {
          await getListStores();

          //get districts by store
          districts.value = [];
          if (0 < storeData.value.length && !error.value.findStoreByProduct) {
            storeData.value.forEach((item) => {
              if (!districts.value.some((store) => store.value === item.city)) {
                districts.value.push({
                  id: item.city,
                  value: item.city,
                  latitude: item.latitude,
                  longitude: item.longitude,
                });
              }
            });
          }
        }
      }
    );

    watch(
      () => props.selectedOption,
      async (newSize, oldSize) => {
        if (!selectedCity.value?.id) return;

        await getListStores();

        if (selectedDistrict.value?.label) {
          listStores.value = storeData.value.filter(
            (store) => store.city === selectedDistrict.value.label
          );
        }
      },
      { deep: true }
    );

    const getListStores = async () => {
      const params = {
        city_id: selectedCity.value.id,
        sku: props.parentSku,
        color: props.selectedOption?.color?.label,
        size: props.selectedOption?.size?.label,
      };
      storeData.value = await findStoreByProduct(params);
      listStores.value = storeData.value;

      // Track store availability results after getting stores
      if (storeData.value && storeData.value.length > 0) {
        trackStoreAvailability();
      }
    };

    const openOption = () => {
      isOpenOption.value = isOpenOption.value === "active" ? "" : "active";
    };

    const openOptionDistrict = () => {
      isOpenOptionDistrict.value =
        isOpenOptionDistrict.value === "active" ? "" : "active";
    };

    const timeOpenCloseStore = (store) => {
      var dayData = getCurrentDay();
      var dayTimeOpen = [
        "sunday_open",
        "monday_open",
        "tuesday_open",
        "wednesday_open",
        "thursday_open",
        "friday_open",
        "saturday_open",
      ];
      var dayTimeClose = [
        "sunday_close",
        "monday_close",
        "tuesday_close",
        "wednesday_close",
        "thursday_close",
        "friday_close",
        "saturday_close",
      ];
      return {
        timeOpen: store[dayTimeOpen[dayData.day]],
        timeClose: store[dayTimeClose[dayData.day]],
      };
    };

    watch(
      () => props.parentSku,
      async (newSku) => {
        if (newSku) {
          await fetchProductData();
        }
      }
    );

    return {
      states,
      chooseCity,
      openSelect,
      openOption,
      isOpenOption,
      isOpenOptionDistrict,
      openOptionDistrict,
      selectedDistrict,
      selectedCity,
      storeData,
      gotoGgMap,
      getStoreStatusText,
      getStoreStatusStyle,
      timeOpenCloseStore,
      districts,
      chooseDistrict,
      listStores,
      loading,
      trackStoreAvailability,
    };
  },
});
